/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockMoveBackIcon24Regular = forwardRef('TimeClockMoveBackIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M13.467 3.881A8.25 8.25 0 0 0 4.652 8.25H7.5a.75.75 0 1 1 0 1.5H3A.75.75 0 0 1 2.25 9V4.246a.75.75 0 1 1 1.5 0v2.558a9.75 9.75 0 1 1-.778 8.877.75.75 0 1 1 1.389-.566A8.25 8.25 0 1 0 13.467 3.88Z" }),
        React.createElement("path", { d: "M11.75 6.563a.75.75 0 0 1 .75.75v3.948c0 .284.16.543.415.67l3.295 1.648a.75.75 0 1 1-.67 1.342l-3.296-1.648A2.25 2.25 0 0 1 11 11.26V7.313a.75.75 0 0 1 .75-.75Z" })));
});
